module.exports = __webpack_public_path__ + "img/attack_whitestorm.20440541.png";